// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import app from '@/src/app'
import appRouter from '@/src/appRouter.js'
import store from '@/store/index'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/lib/util/colors'
import VueAxiosPlugin from '@/plugins/axios-interceptor'
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import InfiniteLoading from 'vue-infinite-loading'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import '../../static/stylesheets/application.scss'
import VueHead from 'vue-head'
import VueI18n from 'vue-i18n'
import '@/plugins/sentry'
import 'text-security/text-security.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import jaMessages from '../src/jaTranslations'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import Editor from '@tinymce/tinymce-vue'
import '@/plugins/tinymce/config'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueCodemirror, {
  options: { theme: 'base16-dark' },
  events: ['scroll']
})

Vue.config.productionTip = false
Vue.use(VueAxiosPlugin, { store: store, router: appRouter })

Vue.use(VueHead)

Vue.use(Vuetify)
const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#315ED9',
        warning: colors.yellow.darken2,
        success: colors.green.darken1,
        danger: colors.red.darken2
      }
    }
  }
})

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi'
})

Vue.use(InfiniteLoading)

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja',
  messages: jaMessages
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: appRouter,
  store,
  vuetify,
  i18n,
  components: { app },
  template: '<app/>'
})

Vue.use(VueCodemirror, {
  options: { theme: 'base16-dark' },
  events: ['scroll']
})

library.add(fas)
library.add(far)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('Editor', Editor)

Vue.use(VueScrollTo, {
  container: '#ScrollableSidebar',
  duration: 500
})
